
export const DRAFT_BOARD_AUTHOR = {
  name: 'Adam Lamberti',
  profilePicture: 'https://img.premierlacrosseleague.com/2025/thumbnail_Adam_Lamberti.webp',
}
